export enum ValuePositionEnum {
    center = 'center',
    left = 'left',
    right = 'right'
}
